import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import SVButton from 'components/elements/SVButton';

interface PRQSubmitReviewConfirmationProps {
  onSubmit: () => void;
  onCancel: () => void;
}

const PRQSubmitReviewConfirmation: React.FC<PRQSubmitReviewConfirmationProps> = ({
  onSubmit,
  onCancel,
}) => {
  const [satisfied, setSatisfied] = useState(false);

  return (
    <Modal show onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Final Submit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you are ready to submit your final comments? This cannot
          be undone.
        </p>
        <p>
          <input
            type="checkbox"
            style={{ marginRight: '1rem' }}
            onChange={(event) => setSatisfied(event.target.checked)}
          />
          I am satisfied with the comments added to this form and wish to
          submit.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <SVButton variant="cancel" onClick={onCancel}>
          Cancel
        </SVButton>
        <SVButton
          size="sm"
          variant="secondary"
          onClick={onSubmit}
          disabled={!satisfied}
        >
          Submit
        </SVButton>
      </Modal.Footer>
    </Modal>
  );
};

export default PRQSubmitReviewConfirmation;
